/* eslint-disable react/prop-types */
import React, { Component } from "react";

class PDFViewer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      isFullscreen: false,
      zoom: 100,
      error: null,
      loading: false,
    };
    this.iframeRef = React.createRef();
  }

  componentDidMount() {
    document.addEventListener("keydown", this.handleKeyDown);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown);
  }

  handleKeyDown = (event) => {
    if (event.key === "Escape" && this.state.isFullscreen) {
      this.setState({ isFullscreen: false });
    }
  };

  handleIframeLoad = () => {
    this.setState({ loading: false });
  };

  handleIframeError = () => {
    this.setState({
      loading: false,
      error: "PDF dosyası yüklenirken bir hata oluştu.",
    });
  };

  toggleAccordion = () => {
    this.setState((prevState) => {
      const newIsOpen = !prevState.isOpen;
      if (newIsOpen && !prevState.loading && !this.state.error) {
        return { isOpen: newIsOpen, loading: true };
      }
      return { isOpen: newIsOpen };
    });
  };

  toggleFullscreen = () => {
    this.setState((prevState) => ({
      isFullscreen: !prevState.isFullscreen,
    }));
  };

  handleZoomIn = () => {
    this.setState((prevState) => ({
      zoom: Math.min(prevState.zoom + 10, 200),
    }));
  };

  handleZoomOut = () => {
    this.setState((prevState) => ({
      zoom: Math.max(prevState.zoom - 10, 50),
    }));
  };

  resetZoom = () => {
    this.setState({ zoom: 100 });
  };

  render() {
    const { title, filePath } = this.props;
    const { loading, error, isOpen, isFullscreen, zoom } = this.state;

    const headerStyle = {
      backgroundColor: "#f8f9fa",
      border: "1px solid #e0e0e0",
      borderRadius: isOpen ? "8px 8px 0 0" : "8px",
      padding: "12px 20px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      cursor: "pointer",
      transition: "all 0.3s ease",
      ":hover": {
        backgroundColor: "#e9ecef",
      },
    };

    const containerStyle = isFullscreen
      ? {
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "#525659",
          zIndex: 9999,
          display: "flex",
          flexDirection: "column",
        }
      : {
          border: "1px solid #e0e0e0",
          borderTop: "none",
          borderRadius: "0 0 8px 8px",
          backgroundColor: "#fff",
          boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
          overflow: "hidden",
          height: isOpen ? "600px" : "0",
          transition: "height 0.3s ease",
          display: "flex",
          flexDirection: "column",
        };

    const toolbarStyle = {
      backgroundColor: "#f8f9fa",
      padding: "8px 20px",
      borderBottom: "1px solid #e0e0e0",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      flexShrink: 0,
    };

    const contentStyle = {
      flex: 1,
      position: "relative",
      backgroundColor: "#525659",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    };

    const pdfUrl = `${filePath}#toolbar=0&navpanes=0&scrollbar=1&page=1&view=FitH`;

    return (
      <div>
        <div
          style={headerStyle}
          onClick={this.toggleAccordion}
          onMouseEnter={(e) => (e.target.style.backgroundColor = "#e9ecef")}
          onMouseLeave={(e) => (e.target.style.backgroundColor = "#f8f9fa")}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path
                d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z"
                stroke="#dc2626"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <polyline
                points="14,2 14,8 20,8"
                stroke="#dc2626"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <text
                x="12"
                y="15"
                textAnchor="middle"
                fontSize="6"
                fill="#dc2626"
                fontWeight="bold"
              >
                PDF
              </text>
            </svg>
            <span style={{ fontWeight: "500", color: "#333" }}>{title}</span>
          </div>

          <div
            style={{
              transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
              transition: "transform 0.3s ease",
            }}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <polyline
                points="6,9 12,15 18,9"
                stroke="#666"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </div>

        {isOpen && (
          <div
            style={
              isFullscreen
                ? {
                    position: "fixed",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: "#525659",
                    zIndex: 9999,
                    display: "flex",
                    flexDirection: "column",
                  }
                : containerStyle
            }
          >
            <div style={contentStyle}>
              {loading && (
                <div
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    textAlign: "center",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "10px",
                    backgroundColor: "rgba(255,255,255,0.9)",
                    padding: "15px",
                    borderRadius: "6px",
                  }}
                >
                  <div
                    style={{
                      width: "20px",
                      height: "20px",
                      border: "2px solid #f3f3f3",
                      borderTop: "2px solid #dc2626",
                      borderRadius: "50%",
                      animation: "spin 1s linear infinite",
                    }}
                  />
                  <span style={{ fontSize: "14px", color: "#666" }}>
                    Yükleniyor...
                  </span>
                  <style>
                    {`
                      @keyframes spin {
                        0% { transform: rotate(0deg); }
                        100% { transform: rotate(360deg); }
                      }
                    `}
                  </style>
                </div>
              )}

              {error && (
                <div
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    padding: "30px",
                    textAlign: "center",
                    backgroundColor: "white",
                    color: "#c00",
                    borderRadius: "6px",
                    fontSize: "14px",
                    boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
                  }}
                >
                  <div>{error}</div>
                </div>
              )}

              <iframe
                ref={this.iframeRef}
                src={pdfUrl}
                style={{
                  width: "50%",
                  height: "100%",
                  border: "none",
                }}
                title={title}
                onLoad={this.handleIframeLoad}
                onError={this.handleIframeError}
              />
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default PDFViewer;
